export default {"src":"/_next/static/media/guarentee.13a0eef8.svg","height":42,"width":42};